import { render, staticRenderFns } from "./ShiftWidget.vue?vue&type=template&id=359cd392&"
import script from "./ShiftWidget.vue?vue&type=script&lang=js&"
export * from "./ShiftWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports